<div class="error-container">
    <div class="error-card">
        <p class="error-status">404<p>
        <p class="error-title">Oops!</p>
        <p class="mt-4 error-description">We’re sorry, <br/> The page you were looking for doesn’t exist anymore</p>
        <button mat-flat-button class="btn-large btn-primary mt-30" (click)="navigateTo()">Back to Home</button> 
    </div>
</div>